<app-fullcalendar
  [events]="events"
  (onAddClick)="AddButton()"
  (onDeleteClick)="DeleteButton($event)"
  (onEditClick)="EditButton($event)"
  (onDateChanged)="DateChanged($event)"
  [Modificabile]="true"
  [(Stampe)]="Stampe"
 ></app-fullcalendar>
